<template>
  <div
      class="content-block Innovation-block"
      data-aos="fade-up"
      data-aos-duration="800"
  >
    <div class="block-left">
      <div class="block-number">04</div>
      <BlockHeader
          title="研发创新"
          subtitle="智造美味，科创赋能"
          subtitleEn="R&D INNOVATION"
      />
      <div class="block-ornament">
        <div class="ornament-item"></div>
        <div class="ornament-item"></div>
        <div class="ornament-item"></div>
      </div>
    </div>
    <div class="block-right">
      <div class="block-content">
        <div class="Innovation-features">
          <div class="feature-item">
            <div class="feature-title">
              与浙江大学、江南大学、宁波智能研究院、浙江万里学院、宁波财经学院合作
            </div>
            <div class="feature-content">
              <p>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                聚焦"传统风味+现代技术"的适配升级，落地3项核心食品加工技术优化：
              <ul>
                <li>
                  <b>提升牛肉干口感嫩度：</b>
                  通过智能工艺调整卤制、风干参数，让传统卤味既保留宁波老风味的醇厚，又适配现代消费者偏好的软嫩口感
                </li>
                <li>
                  <b>延长牛肉干保质期1个月以上：</b>
                  在不添加额外防腐剂的前提下，通过智能锁鲜技术优化，既保障食品天然属性，又提升终端流通效率
                </li>
                <li>
                  <b>牛胶原蛋白应用升级：</b>
                  将牛副产物中的胶原蛋白科学复配至产品中，既提升食品的营养密度，也强化食品安全的溯源与可控性。
                </li>
              </ul>
              </p>
            </div>
          </div>
          <div class="feature-item feature-item-with-image">
            <div class="feature-title">后续合作方向</div>
            <div class="feature-content-wrapper">
              <div class="feature-text">
                <p>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  围绕"老字号焕新+行业标杆"目标，拓展5大技术合作维度：
                <ul>
                  <li>
                    <b>食品加工技术深化：</b>
                    针对宁波本土特色食材，研发适配休闲食品的智能加工工艺
                  </li>
                  <li>
                    <b>设备智能化升级：</b>
                    引入自动化调味系统，提升生产效率与产品口味的稳定性
                  </li>
                  <li>
                    <b>副产品开发：</b>
                    挖掘牛肉加工副产物的食用价值，开发健康零食、调味基料等衍生产品
                  </li>
                  <li>
                    <b>新质生产力赋能：</b>
                    用数字化技术优化配方研发、供应链管理
                  </li>
                  <li>
                    <b>国际标准认证体系建设：</b>
                    搭建全链路国际标准认证体系，助力品牌拓展国内外市场
                  </li>
                </ul>
                </p>
              </div>
              <div class="feature-image">
                <img src="@/assets/innovation/1.jpg" alt="后续合作方向示意图">
              </div>
            </div>
          </div>
          <div class="feature-item">
            <div class="feature-title">合作成果落地</div>
            <div class="feature-content">
              <p>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                2024年，依托与浙大智能研究院的技术优化成果，太丰古法卤牛肉干凭借"风味保留度+口感升级+营养强化"的综合优势，斩获"iSEE全球美味奖2星"，成为宁波老字号食品技术升级的代表性成果之一。
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BlockHeader from '../common/BlockHeader.vue';

export default {
  components: {  BlockHeader },
  name: "SaleBlock",
};
</script>

<style scoped>
.Innovation-block {
  display: flex;
  background: linear-gradient(135deg, #ffffff 0%, #fafafa 100%);
  border-radius: 15px;
  margin-bottom: 40px;
  border: 1px solid rgba(154, 27, 30, 0.1);
  box-shadow: 0 8px 25px rgba(154, 27, 30, 0.08);
  overflow: hidden;
  position: relative;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.Innovation-block:hover {
  transform: translateY(-5px);
  border-color: rgba(154, 27, 30, 0.3);
  box-shadow: 0 15px 35px rgba(154, 27, 30, 0.12);
}

.Innovation-block .block-left {
  flex: 0 0 280px;
  padding: 35px 25px;
  position: relative;
  overflow: hidden;
  background: linear-gradient(135deg, rgba(154, 27, 30, 0.05), transparent);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-right: 1px solid rgba(154, 27, 30, 0.1);
}

.Innovation-block .block-number {
  position: absolute;
  top: 15px;
  left: 15px;
  font-size: 3.5rem;
  font-weight: 900;
  color: rgba(154, 27, 30, 0.05);
  z-index: 0;
}

.Innovation-block .block-ornament {
  position: absolute;
  bottom: 25px;
  display: flex;
  gap: 6px;
}

.Innovation-block .ornament-item {
  width: 3px;
  height: 18px;
  background: linear-gradient(to top, #9a1b1e, transparent);
  border-radius: 1.5px;
}

.Innovation-block .ornament-item:nth-child(2) {
  height: 24px;
  background: linear-gradient(to top, #b22222, transparent);
}

.Innovation-block .ornament-item:nth-child(3) {
  height: 20px;
  background: linear-gradient(to top, #d32f2f, transparent);
}

.Innovation-block .block-right {
  flex: 1;
  padding: 35px 30px;
  position: relative;
  z-index: 1;
}

.Innovation-block .block-content {
  margin-bottom: 25px;
}

.Innovation-block .block-desc {
  font-size: 1rem;
  line-height: 1.7;
  color: #444;
  margin-bottom: 25px;
  text-align: justify;
}

.Innovation-block .Innovation-features {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 15px;
  margin-top: 25px;
}

.Innovation-block .feature-item {
  background: white;
  border-radius: 10px;
  padding: 18px;
  border: 1px solid rgba(154, 27, 30, 0.08);
  transition: all 0.3s;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.02);
}

.Innovation-block .feature-item:hover {
  background: rgba(154, 27, 30, 0.03);
  border-color: rgba(154, 27, 30, 0.2);
  transform: translateY(-3px);
  box-shadow: 0 6px 15px rgba(154, 27, 30, 0.08);
}

.Innovation-block .feature-icon {
  width: 45px;
  height: 45px;
  background: linear-gradient(135deg, #9a1b1e, #b22222);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
}

.Innovation-block .feature-icon i {
  font-size: 1.3rem;
  color: white;
}

.Innovation-block .feature-title {
  padding: 10px 20px;
  background: linear-gradient(135deg, #9a1b1e, #b2222244);
  border-radius: 10px;
  color: #fff;
}

.Innovation-block .feature-content h4 {
  font-size: 1.1rem;
  color: #222;
  margin-bottom: 5px;
  font-weight: 600;
}

.Innovation-block .feature-content p {
  font-size: 1rem;
  color: #444;
  line-height: 1.7;
}

.Innovation-block .feature-content p ul li {
  margin-bottom: 10px;
}

.Innovation-block .block-footer {
  display: flex;
  justify-content: flex-end;
}

.Innovation-block .block-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: linear-gradient(135deg, #9a1b1e, #b22222);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 50px;
  cursor: pointer;
  font-weight: 700;
  transition: all 0.3s;
  font-size: 0.95rem;
  letter-spacing: 0.5px;
  box-shadow: 0 8px 20px rgba(154, 27, 30, 0.2);
  position: relative;
  overflow: hidden;
  text-decoration: none;
}

.Innovation-block .block-btn::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.2),
    transparent
  );
  transition: left 0.5s;
}

.Innovation-block .block-btn:hover {
  transform: translateX(5px);
  box-shadow: 0 12px 30px rgba(154, 27, 30, 0.3);
  color: white;
  text-decoration: none;
  background: linear-gradient(135deg, #b22222, #d32f2f);
}

.Innovation-block .block-btn:hover::before {
  left: 100%;
}

.Innovation-block .block-btn i {
  transition: transform 0.3s;
}

.Innovation-block .block-btn:hover i {
  transform: translateX(5px);
}

@media (max-width: 1200px) {
  .Innovation-block .block-left {
    flex: 0 0 250px;
  }

  .Innovation-block .Innovation-features {
    grid-template-columns: repeat(1, 1fr);
  }
}

@media (max-width: 992px) {
  .Innovation-block {
    flex-direction: column;
  }

  .Innovation-block .block-left {
    flex: 0 0 auto;
    padding: 30px 25px;
    border-right: none;
    border-bottom: 1px solid rgba(154, 27, 30, 0.1);
  }

  .Innovation-block .block-right {
    padding: 30px 25px;
  }
}

@media (max-width: 768px) {
  .Innovation-block .block-left {
    padding: 25px 20px;
  }

  .Innovation-block .block-right {
    padding: 25px 20px;
  }

  .Innovation-block .block-title {
    font-size: 1.6rem;
  }

  .Innovation-block .Innovation-features {
    grid-template-columns: 1fr;
  }

  .Innovation-block .block-btn {
    width: 100%;
    justify-content: center;
  }
}

.Innovation-block::after {
  content: "";
  position: absolute;
  top: -50%;
  right: -50%;
  width: 200px;
  height: 200px;
  background: radial-gradient(
    circle,
    rgba(154, 27, 30, 0.03) 0%,
    transparent 70%
  );
  z-index: 0;
}

.Innovation-block > * {
  position: relative;
  z-index: 1;
}



.Innovation-block .feature-item-with-image {
  padding: 0;
  overflow: hidden;
}

.Innovation-block .feature-item-with-image .feature-title {
  padding: 15px 20px;
  margin: 0;
  border-radius: 10px 10px 0 0;
}

.Innovation-block .feature-item-with-image .feature-content-wrapper {
  display: flex;
  align-items: stretch;
  min-height: 240px;
}

.Innovation-block .feature-item-with-image .feature-text {
  flex: 1;
  padding: 25px;
  background: rgba(255, 255, 255, 0.9);
}

.Innovation-block .feature-item-with-image .feature-text p {
  margin-bottom: 0;
}

.Innovation-block .feature-item-with-image .feature-text ul {
  margin-top: 15px;
  margin-bottom: 0;
}

.Innovation-block .feature-item-with-image .feature-image {
  flex: 0 0 33%;
  height: 100%;
  overflow: hidden;
  position: relative;
  margin-top: 5px;
}

.Innovation-block .feature-item-with-image .feature-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.Innovation-block .feature-item-with-image:hover .feature-image img {
  transform: scale(1.05);
}

.Innovation-block .feature-item-with-image .image-placeholder {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(154, 27, 30, 0.1), rgba(178, 34, 34, 0.05));
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.Innovation-block .feature-item-with-image .image-placeholder::before {
  content: "合作示意图";
  color: rgba(154, 27, 30, 0.4);
  font-size: 1.2rem;
  font-weight: 600;
}

@media (max-width: 992px) {
  .Innovation-block .feature-item-with-image .feature-content-wrapper {
    flex-direction: column;
    min-height: auto;
  }

  .Innovation-block .feature-item-with-image .feature-text {
    padding: 20px;
  }

  .Innovation-block .feature-item-with-image .feature-image {
    flex: 0 0 250px;
    width: 100%;
    order: -1;
  }
}

@media (max-width: 768px) {
  .Innovation-block .feature-item-with-image .feature-content-wrapper {
    flex-direction: column;
  }

  .Innovation-block .feature-item-with-image .feature-image {
    flex: 0 0 200px;
  }
}

</style>
